import React from 'react';

import { useActivityContext } from './use-activity.context';
import { useLessonSettings } from './use-lesson-settings';
import { PlayerViewerType } from '..';
import { TemplateType } from '../enums/template-type';

const isAllowedActivities = [
  TemplateType.DIB,
  TemplateType.DIB_EXTENDED,
  TemplateType.MC,
  TemplateType.MC_EXTENDED,
  TemplateType.UNSCRAMBLE,
  TemplateType.UNSCRAMBLE_EXTENDED,
  TemplateType.FOURSQ,
  TemplateType.FOURSQ_EXTENDED,
  TemplateType.DND,
  TemplateType.DND_EXTENDED,
  TemplateType.TIB,
  TemplateType.TIB_EXTENDED,
];

export function useShowCopilotButton() {
  const { copilotEnabled } = useLessonSettings();
  const { viewerType, currentActivity } = useActivityContext();

  const isAllowedActivity = React.useMemo(() => {
    return isAllowedActivities.includes(currentActivity.templateName);
  }, [currentActivity.templateName]);

  return {
    copilotEnabled,
    showCopilot:
      copilotEnabled &&
      viewerType === PlayerViewerType.LESSON &&
      isAllowedActivity,
  };
}
